function Header() {
  return (
    <div className="header">
      <h1>🚀 Smart Learning Finder</h1>
      <p>Personalized learning powered by intelligent crawling</p>
    </div>
  );
}

export default Header;